import AddToCartModal from './AddToCartModal.vue'

export default AddToCartModal
